import { Button, Stack, Text, Title } from '@mantine/core';

import { useTranslation } from '@apple/lib/i18next';
import { SimpleLayout } from '@apple/ui/layouts/simple';
import { Link } from '@apple/ui/link/Link';

export function NotFoundPage() {
	const { t } = useTranslation('common');

	return (
		<SimpleLayout fluid>
			<Stack align='center'>
				<Title>{t('error.notFound.title')}</Title>
				<Text>{t('error.notFound.message')}</Text>
				{/* FIXME: This button is redirecting to home but says back */}
				<Button h='xl' variant='outline' component={Link} to='/'>
					{t('buttons.goBack')}
				</Button>
			</Stack>
		</SimpleLayout>
	);
}
